<template>
  <div>
      <video autoplay muted loop class="hover_video" src="@/assets/video/watchwin.mp4"></video>
      <p class="description pd-top-40">
        Vision+ mempersembahkan kuis Watch & Win. Sesuai dengan namanya Watch & Win, adalah sebuah kuis dimana peserta harus menonton Vision+ Original Series dengan judul yang sudah ditentukan dan menjawab sebuah pertanyaan yang tertera di dalam series tersebut. Jadi jangan sampai ketinggalan dan saksikan terus Original Series dari Vision+ ya.
      </p>
      <!-- <p class="link description mg-top-20" @click="movePage()">Selengkapnya</p> -->
  </div>
</template>

<script>
export default {
  name: 'Visions',
  data () {
    return {

    }
  },
  methods: {
    movePage() {
      this.$router.push('/visions-plus')
    }
  }
}
</script>
